import type { Colourist } from '../layers.ts';
import type { CellInfo, Store } from '../store.ts';
import { clear, el, pct, votes } from './dom.ts';

/** Click pins a cell and shows the full breakdown; this is where a contested cell becomes legible (SPEC §9.5). */
export function mountDetail(root: HTMLElement, store: Store, colourist: () => Colourist): void {
  const render = (c: CellInfo | null) => {
    clear(root);
    if (!c) { root.hidden = true; return; }
    root.hidden = false;
    const locs = store.locationsFor();
    const win = locs.get(c.code);
    const ru = c.runnerUp ? locs.get(c.runnerUp) : null;
    const agreement = c.total > 0 ? c.score / c.total : 0;
    const sw = (code: string) => { const s = el('span', { class: 'swatch', 'aria-hidden': 'true' }); s.style.background = colourist().css(code) ?? 'transparent'; return s; };
    const close = el('button', { class: 'btn secondary', type: 'button', text: 'Close', 'aria-label': 'Close details' });
    close.style.cssText = 'position:absolute;top:10px;right:10px;padding:4px 10px;font-size:12px;box-shadow:none';
    close.addEventListener('click', () => store.set({ selected: null }));
    root.style.position = 'fixed';
    root.append(
      close,
      el('h2', { text: `Cell · precision ${c.cell.length}` }),
      el('div', { class: 'cell', text: c.cell }),
      el('div', { class: 'big' }, sw(c.code), el('span', { text: win?.name ? `${win.name} (${c.code})` : c.code })),
      el('p', {}, el('strong', { text: `${votes(c.total)} votes` }), ` · ${pct(agreement)} agree`),
      c.runnerUp
        ? el('p', {}, 'runner-up ', sw(c.runnerUp), ' ', el('strong', { text: ru?.name ? `${ru.name} (${c.runnerUp})` : c.runnerUp }), ` · ${pct(1 - agreement)} of votes go elsewhere`)
        : el('p', { text: 'Uncontested so far.' }),
    );
    if (c.boot > 0.05) root.append(el('p', { text: `${pct(c.boot)} of these votes came from cold-start plans and are down-weighted.` }));
    if (agreement < 0.6 && c.total >= 3) root.append(el('p', { text: 'A contested cell: a catchment boundary probably runs through it.' }));
  };
  render(null);
  store.subscribe((s, changed) => { if (changed.has('selected') || changed.has('provider') || changed.has('locations')) render(s.selected); });
}
